import { lazy } from "react";
import { ScrollText } from "lucide-react";
import type { AdminModule } from "../types";

const AuditBrowser = lazy(() =>
  import("./pages/AuditBrowser").then((m) => ({ default: m.AuditBrowser })),
);

export const auditModule: AdminModule = {
  key: "audit",
  label: "Audit log",
  description: "Every privileged action: who did it, to what, and why.",
  group: "operations",
  icon: ScrollText,
  requiredPermission: "admin.audit.read",
  routes: [{ path: "", element: <AuditBrowser /> }],
};
